import Loader from "components/UI/loader/Loader";
import { useState, useEffect } from "react";
import AcordionBlock from 'components/UI/acordionBlock/AcordionBlock';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import Strings from "values/Strings";
import MentorService from "services/MentorService";
import { useFetching } from "components/hooks/useFetching";
import OccasionService from "services/OccasionService";
import { useDispatch } from "react-redux";
import { changeLoaderStatus } from "redux/slice/loaderSlice";
import { newName } from "redux/slice/titleSlice";
import 'styles/css/team-grade-mentor.css'
import TitleMain from "components/UI/titleMain/TitleMain";
import CaseContainer from "components/UI/case/caseContainer/CaseContainer";
import CircularChart from "components/UI/circleChart/CircleChart";
import { useDeviceType } from "components/hooks/useDeviceType";
import { setSidebarItem } from "redux/slice/sidebarItemSlice";
function TeamGradeMentorPage() {


    const notificationWarning = (error) => {
        if (error.response && error.response.data && error.response.data.message) {
            NotificationManager.warning(`${error.response.data.message}`, Strings.notificationsWarningTitle, 5000);
        } else {
            NotificationManager.warning(`${error.message}`, Strings.notificationsWarningTitle, 5000);
        }
    }
    const notificationError = (error) => {
        if (error.response && error.response.data && error.response.data.message) {
            NotificationManager.error(`${error.response.data.message}`, Strings.notificationsErrorTitle, 5000);
        } else {
            NotificationManager.error(`${error.message}`, Strings.notificationsErrorTitle, 5000);
        }
    }

    const [studen, setStuden] = useState(0);
    const [school, setSchool] = useState(0);
    const [command, setCommand] = useState(0);
    const [allPart, setAllPart] = useState(0);

    const [accordionBlock, setAccordionBlock] = useState(null)

    const [fetchingProfileMentor, loadingProfileMentor, errorProfileMentor] = useFetching(async (data) => {
        try {
            console.log('🔍 [TeamGradeMentorPage] fetchingProfileMentor вызван с data:', data);
            const mass = []
            const elementFormap = []

            if (data) {
                let newStuden = 0;
                let newSchool = 0;
                let newAllPart = 0;

                console.log('📡 [TeamGradeMentorPage] Запрос к MentorService.getProfileMentor с occasion_id:', data);
                const res = await MentorService.getProfileMentor(data)
                console.log('✅ [TeamGradeMentorPage] Получен ответ от MentorService.getProfileMentor:', res);
                console.log('📊 [TeamGradeMentorPage] Количество элементов в ответе:', res?.length);

                res.forEach(element => {
                    mass.push(element["id_command"])
                });
                console.log('📋 [TeamGradeMentorPage] Массив id_command:', mass);
                const uniqueMass = [...new Set(mass)];
                console.log('🔢 [TeamGradeMentorPage] Уникальные id_command:', uniqueMass);
                console.log('👥 [TeamGradeMentorPage] Количество уникальных команд:', uniqueMass.length);
                
                uniqueMass.forEach(element => {
                    const filtered = res.filter(obj => obj.id_command === element)
                    console.log(`🏷️ [TeamGradeMentorPage] Команда ${element}:`, filtered);
                    elementFormap.push(filtered)
                });
                console.log('📦 [TeamGradeMentorPage] elementFormap (сгруппированные команды):', elementFormap);

                res.forEach(element => {
                    if (element.status === "студент") {
                        newStuden += 1
                    }
                    if (element.status === "школьник") {
                        newSchool += 1
                    }
                    newAllPart += 1
                });

                console.log('📈 [TeamGradeMentorPage] Статистика:', {
                    студенты: newStuden,
                    школьники: newSchool,
                    всего: newAllPart,
                    команд: uniqueMass.length
                });

                setStuden(newStuden);
                setSchool(newSchool);
                setCommand(uniqueMass.length);
                setAllPart(newAllPart);

                const accordionElements = elementFormap.map((value, key) => {
                    console.log(`🎯 [TeamGradeMentorPage] Создание AcordionBlock для команды ${value[0]?.id_command}:`, {
                        teamName: value[0]["command_name"],
                        caseName: value[0]["title"],
                        tableNumber: value[0]["table_number"],
                        participants: value.length
                    });
                    return <AcordionBlock table={value} presentation={value[0]["presentation"]} key={`${value[0]?.id_command}_${key}`} addational_material={value[0]["additional_material"]} teamName={value[0]["command_name"]} tableNumber={value[0]["table_number"]} caseName={value[0]["title"]} />
                });
                
                console.log('🎨 [TeamGradeMentorPage] Создано accordion элементов:', accordionElements.length);
                setAccordionBlock(accordionElements);
                console.log('✅ [TeamGradeMentorPage] accordionBlock установлен');
            } else {
                console.warn('⚠️ [TeamGradeMentorPage] data не определено');
                notificationWarning(Strings.profilieMentorUndefinedOccasionId)
            }
        } catch (error) {
            console.error('❌ [TeamGradeMentorPage] Ошибка в fetchingProfileMentor:', error);
            notificationWarning(error)
        }
    })

    const device = useDeviceType()
    const dispatch = useDispatch()
    const [currentOccasion, setCurrentOccasion] = useState(null)

    useEffect(() => {
        dispatch(setSidebarItem(Strings.sidebarGrade))
    }, [])

    const [getCurrentOccasions, loadingCurrentOccasions, errorCurrentOccasions] = useFetching(async () => {
        try {
            console.log('🎯 [TeamGradeMentorPage] Запрос к OccasionService.getOccasionsForMentor');
            const res = await OccasionService.getOccasionsForMentor()
            console.log('✅ [TeamGradeMentorPage] Получено мероприятие:', res);
            console.log('🆔 [TeamGradeMentorPage] ID мероприятия:', res?.id);
            setCurrentOccasion(res)
            if (res?.id) {
                console.log('📞 [TeamGradeMentorPage] Вызов fetchingProfileMentor с id:', res.id);
                fetchingProfileMentor(res.id)
            } else {
                console.warn('⚠️ [TeamGradeMentorPage] У мероприятия нет id');
            }
            dispatch(changeLoaderStatus(false))
        } catch (error) {
            console.error('❌ [TeamGradeMentorPage] Ошибка в getCurrentOccasions:', error);
            notificationError(error)
        }
    })

    useEffect(() => {
        getCurrentOccasions()
        dispatch(newName(Strings.profilieMentorTitle))
    }, [])

    console.log('🎨 [TeamGradeMentorPage] Рендер компонента:', {
        loadingProfileMentor,
        command,
        allPart,
        accordionBlockLength: accordionBlock?.length,
        currentOccasion: currentOccasion?.id,
        accordionBlockType: typeof accordionBlock,
        accordionBlockIsArray: Array.isArray(accordionBlock)
    });

    return (
        <Loader localStatus={loadingProfileMentor}>
            <TitleMain text={"Информация о командах"} jsc="center" fns="1.5vw" elpSize="0.9vw" />
            {command > 0 &&
                <div style={{ display: "flex", flexDirection: device === "phone" ? "column" : "row", marginBottom: device === "phone" ? "10vw" : "3vw" }}>
                    <div style={{ display: "flex", justifyConten: "space-betwen", width: "100%" }}>
                        <CircularChart
                            titleUnderChart="Кол-во команд"
                            percentText={command}
                            percentChart={100}
                            percentUnderText="шт."
                        />
                        <CircularChart
                            titleUnderChart="Кол-во участников"
                            percentText={allPart}
                            percentChart={100}
                            percentUnderText="шт."
                        />
                    </div>
                    <div style={{ display: "flex", width: "100%" }}>
                        <CircularChart
                            titleUnderChart="Процент студентов"
                            percentText={`${(studen / allPart * 100).toFixed(0)}%`}
                            percentChart={(studen / allPart * 100).toFixed(0)}
                        />
                        <CircularChart
                            titleUnderChart="Процент школьников"
                            percentText={`${(school / allPart * 100).toFixed(0)}%`}
                            percentChart={(school / allPart * 100).toFixed(0)}
                        />
                    </div>

                </div>
            }
            {/* <h3 className='h3__style'>Информация о командах</h3> */}
            {(() => {
                console.log('🔍 [TeamGradeMentorPage] Проверка условий рендера:', {
                    'accordionBlock?.length > 0': accordionBlock?.length > 0,
                    'accordionBlock': !!accordionBlock,
                    'currentOccasion !== null': currentOccasion !== null,
                    'accordionBlock?.length === 0': accordionBlock?.length === 0
                });
                
                if (accordionBlock?.length > 0 && accordionBlock) {
                    console.log('✅ [TeamGradeMentorPage] Рендерим accordionBlock');
                    return accordionBlock;
                } else if (currentOccasion !== null && accordionBlock?.length === 0) {
                    console.log('📭 [TeamGradeMentorPage] Рендерим "Нет кейсов"');
                    return <CaseContainer text={Strings.mentorProfileNothingCase} />;
                } else {
                    console.log('⏳ [TeamGradeMentorPage] Рендерим "Мероприятие не началось"');
                    return <CaseContainer text={Strings.mentorProfileDontStart} />;
                }
            })()}
        </Loader>
    );
}

export default TeamGradeMentorPage;